import { cn } from '@bem-react/classname';

export const cnTextarea = cn('Textarea');
